var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"web-footer-body"},[_c('div',{staticClass:"footer-web-info-div"},[_vm._v(" Designed and developed by  "),_c('span',{on:{"click":_vm.toGithub}},[_vm._v("@Hoey")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }